import type { ReactNode } from 'react';
import { cn } from '../lib/cn';

export interface CenterStageProps {
  title?: ReactNode;
  subtitle?: ReactNode;
  children: ReactNode;
  className?: string;
}

export function CenterStage({ title, subtitle, children, className }: CenterStageProps) {
  return (
    <div
      className={cn(
        'flex min-h-screen items-center justify-center bg-zinc-50 px-4 py-12',
        className,
      )}
    >
      <div className="w-full max-w-md space-y-6 rounded-lg bg-white p-6 shadow-sm ring-1 ring-zinc-200">
        {(title || subtitle) && (
          <div className="space-y-1 text-center">
            {title && <h1 className="text-xl font-semibold text-zinc-900">{title}</h1>}
            {subtitle && <p className="text-sm text-zinc-500">{subtitle}</p>}
          </div>
        )}
        {children}
      </div>
    </div>
  );
}
